export const API_ENDPOINT = 'https://api-vizitke.euroexpress.ba';
// export const API_ENDPOINT = 'http://localhost:17900';